import React from "react";
import { createRoot } from "react-dom/client";
import { ConfigProvider, unstableSetRender } from "antd";
import ptBR from "antd/locale/pt_BR";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "antd/dist/reset.css";
import "./lib/sentry"; // inicializa Sentry se REACT_APP_SENTRY_DSN estiver presente
import App from "./app/App";
import { AuthProvider } from "./features/auth/AuthContext";
import { Sentry, sentryEnabled } from "./lib/sentry";
import "./App.css";

dayjs.locale("pt-br");

// O antd 5 desenha message, notification e Modal.confirm com o render antigo do
// React, que não existe no React 19: sem isto esses avisos nunca aparecem.
// Receita da documentação do antd para React 19.
unstableSetRender((node, container) => {
  container._reactRoot ||= createRoot(container);
  const reactRoot = container._reactRoot;
  reactRoot.render(node);
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    reactRoot.unmount();
  };
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

const container = document.getElementById("root");
const root = createRoot(container);

const tree = (
  <React.StrictMode>
    <ConfigProvider
      locale={ptBR}
      theme={{
        token: {
          colorPrimary: "#00B6A5",
          colorBgElevated: "#FFFFFF",
          colorText: "#163557",
          colorBorder: "#DBE8F1",
        },
        components: {
          Select: {
            optionSelectedBg: "#DFF8F4",
            optionActiveBg: "#F4FBFA",
            optionSelectedColor: "#133660",
          },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ConfigProvider>
  </React.StrictMode>
);

root.render(
  sentryEnabled ? <Sentry.ErrorBoundary fallback={<p>Erro inesperado</p>}>{tree}</Sentry.ErrorBoundary> : tree,
);
